import { createSelector } from "reselect";

export const categoryFiltersReducerSelector = createSelector(
  state => state.get("categoryFilterReducer"),
  categoryFiltersReducer => categoryFiltersReducer
);
